import {
    SET_BUS_LED_DATA,
    SET_TOTAL_BUS_LED,
    REMOVE_BUS_LED,
    SET_ALL_LINES,
    SET_ALL_LINES_DIRECTIONS,
    SET_BUS_LED_ALL_DATA,
    SET_BUS_LED_PAGE,
    SET_BUS_LED_PAGE_SIZE
} from "../types";

/**
 * Set Bus LED list
 */
export const setBusLedData = (data) => ({
    type: SET_BUS_LED_DATA,
    payload: data,
});

export const setBusLedAllData = (data) => ({
    type: SET_BUS_LED_ALL_DATA,
    payload: data,
});

export const setBusLedPage = (page) => ({
    type: SET_BUS_LED_PAGE,
    payload: page
});

export const setBusLedPageSize = (size) => ({
    type: SET_BUS_LED_PAGE_SIZE,
    payload: size
});


/**
 * Set total Bus LED count
 */
export const setTotalBusLed = (total) => ({
    type: SET_TOTAL_BUS_LED,
    payload: total,
});

export const setAllLines = (data) => ({
    type: SET_ALL_LINES,
    payload: data,
});

export const setAllLinesDirections = (data) => ({
    type: SET_ALL_LINES_DIRECTIONS,
    payload: data,
});


/**
 * Remove all Bus LED data (reset)
 */
export const removeBusLed = () => ({
    type: REMOVE_BUS_LED,
});
